import { isOneOfTags } from 'anodum';
import { EDITABLE_ELEMENTS } from '../constants/editable-elements';

const findRootInlineElement = (element) => {
  const { parentNode } = element;

  if (parentNode.hasAttribute('contenteditable')) return element;

  if (isOneOfTags(parentNode, EDITABLE_ELEMENTS)) {
    return element;
  }

  return findRootInlineElement(parentNode);
};

export default findRootInlineElement;
